<cm-pagination
    [attr.data-total]="total"
    [attr.data-take]="take"
    [attr.data-skip]="skip"
    data-show="3"
    [attr.data-show-totals]="showOptionalControls ? '' : null"
    [attr.data-show-page-size]="showOptionalControls ? '' : null"
    (change)="onPaginationChange($any($event).detail)">
</cm-pagination>




